module.exports = __webpack_public_path__ + "static/correct-c0864a9fc47915c685e86df172c37b55.png";